import { AttentionTypeButton } from "../AttentionTypeButton";
import { ButtonWrapper, Wrapper } from "./styles";
import { Spacer } from "../common/Spacer";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Title } = Typography;

export const AttentionTypeWrapper = ({ onClick, current, desktop }) => {
	const { t } = useTranslation(["booking"]);

	return (
		<Wrapper>
			<div className="current-step-label">
				{t("step")} {current + 1}
			</div>
			<Title level={5}>{t("selectModality")}</Title>
			<Spacer rows={1} />
			<ButtonWrapper>
				<AttentionTypeButton
					desktop={desktop}
					type={"face-to-face"}
					onClick={() => onClick("face-to-face")}
				/>
				<AttentionTypeButton
					desktop={desktop}
					type={"videocall"}
					onClick={() => onClick("videocall")}
				/>
			</ButtonWrapper>
		</Wrapper>
	);
};
